import UseVendorHook from 'hooks/UseVendorHook';
import React, { useEffect, useState } from 'react'

function messageTemplates({user}) {
      const [formData, setFormData] = useState({
    access_token: "",
    instanceId: "",
    businessName: "",
    ownerNumber: "",
    thankYouMessage: "",
  });
  const {updateMessageTemplate} = UseVendorHook()

  useEffect(() => {
    if (user?.vendorDetails) {
      setFormData({
        access_token: user?.vendorDetails?.access_token || "",
        instanceId: user?.vendorDetails?.instanceId || "",
        businessName: user?.vendorDetails?.businessName || "",
        ownerNumber: user?.vendorDetails?.ownerNumber || "",
        thankYouMessage: user?.vendorDetails?.thankYouMessage || "",
      });
    }
  }, [user]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async(e) => {
    e.preventDefault();
    // if (onSubmit) onSubmit(formData);
    let val = {
        ...user,
        vendorDetails: {
            ...user.vendorDetails,  
            thankYouMessage: formData.thankYouMessage,
        }
    }
    await updateMessageTemplate(val);

    // console.log("Form submitted with data:", val);
  };

  return (
  <form
      onSubmit={handleSubmit}
      className="max-w-lg mx-auto bg-white shadow-md rounded-2xl p-6 space-y-4"
    >
      <h2 className="text-xl font-semibold text-gray-700">Edit Vendor Details</h2>

      <div>
        <label className="block text-sm font-medium text-gray-600">Access Token</label>
        <input
          type="text"
          name="access_token"
          value={formData.access_token}
          disabled
          onChange={handleChange}
          className="w-full mt-1 px-3 py-2 border rounded-lg focus:outline-none focus:ring focus:ring-blue-400"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-600">Instance ID</label>
        <input
          type="text"
          name="instanceId"
          disabled
          value={formData.instanceId}
          onChange={handleChange}
          className="w-full mt-1 px-3 py-2 border rounded-lg focus:outline-none focus:ring focus:ring-blue-400"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-600">Business Name</label>
        <input
          type="text"
          name="businessName"
          disabled
          value={formData.businessName}
          onChange={handleChange}
          className="w-full mt-1 px-3 py-2 border rounded-lg focus:outline-none focus:ring focus:ring-blue-400"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-600">Owner Number</label>
        <input
          type="text"
          name="ownerNumber"
          disabled
          value={formData.ownerNumber}
          onChange={handleChange}
          className="w-full mt-1 px-3 py-2 border rounded-lg focus:outline-none focus:ring focus:ring-blue-400"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-600">Thank You Message</label>
        <textarea
          name="thankYouMessage"
          value={formData?.thankYouMessage}
          onChange={handleChange}
          className="w-full mt-1 px-3 py-2 border rounded-lg focus:outline-none focus:ring focus:ring-blue-400"
        />
      </div>

      <button
        type="submit"
        className="w-full bg-[#E3403B] text-white py-2 px-4 rounded-lg hover:bg-[#E3403B]/90 transition"
      >
        Update Vendor
      </button>
    </form>  )
}

export default messageTemplates